/** Default when config has no IANA zone (matches API empty string → UTC). */
export const FALLBACK_COMPANY_TIME_ZONE = "UTC";

/**
 * France métropolitaine + DROM-COM (IANA). Used to pin these at the top of the picker
 * when the full zone list is available, and as the offline fallback list.
 */
export const FRANCE_METROPOLE_AND_OVERSEAS_TIME_ZONES: string[] = [
  "Europe/Paris",
  "America/Guadeloupe",
  "America/Martinique",
  "America/Cayenne",
  "Indian/Reunion",
  "Indian/Mayotte",
  "Pacific/Tahiti",
  "Pacific/Marquesas",
  "Pacific/Gambier",
  "Pacific/Noumea",
  "Pacific/Wallis",
  "America/Miquelon",
  "America/St_Barthelemy",
  "America/Marigot",
];

export function normalizeCompanyTimeZone(raw?: string | null): string {
  const t = (raw || "").trim();
  if (!t) return FALLBACK_COMPANY_TIME_ZONE;
  try {
    Intl.DateTimeFormat(undefined, { timeZone: t });
    return t;
  } catch {
    return FALLBACK_COMPANY_TIME_ZONE;
  }
}

export function listIanaTimeZones(): string[] {
  try {
    const supportedValuesOf = (Intl as unknown as { supportedValuesOf?: (key: string) => string[] })
      .supportedValuesOf;
    if (typeof supportedValuesOf === "function") {
      const all = supportedValuesOf.call(Intl, "timeZone") as string[];
      const set = new Set(all);
      const preferred = FRANCE_METROPOLE_AND_OVERSEAS_TIME_ZONES.filter((z) => set.has(z));
      const preferredSet = new Set(preferred);
      const rest = all.filter((z) => !preferredSet.has(z)).sort((a, b) => a.localeCompare(b));
      return [...preferred, ...rest];
    }
  } catch {
    /* ignore */
  }
  return [
    FALLBACK_COMPANY_TIME_ZONE,
    ...FRANCE_METROPOLE_AND_OVERSEAS_TIME_ZONES,
    "Europe/Brussels",
    "Europe/Zurich",
    "America/Montreal",
    "America/New_York",
    "Africa/Casablanca",
  ];
}
